/** @format */

export const formatStringToSlug = (item) => {
	return item.toString().toLowerCase().replace(/%/g, '').replace(/ /g, '-').replace(/\//g, '-')
}
